/* This file was generated using npm run load-graphql-schema */
export const introspectionQueryResultData = {
  __schema: {
    types: [
      {
        kind: 'INTERFACE',
        name: 'Accessible',
        possibleTypes: [
          {
            name: 'CompetenceCertificate',
          },
          {
            name: 'CourseResult',
          },
          {
            name: 'FeedbackRequest',
          },
          {
            name: 'FeedbackRound',
          },
          {
            name: 'Interview',
          },
          {
            name: 'KPB',
          },
          {
            name: 'Portfolio',
          },
          {
            name: 'Registration',
          },
        ],
      },
      {
        kind: 'INTERFACE',
        name: 'Activities',
        possibleTypes: [
          {
            name: 'CompetenceCertificate',
          },
          {
            name: 'CourseResult',
          },
          {
            name: 'Interview',
          },
          {
            name: 'KPB',
          },
          {
            name: 'MultiSource',
          },
          {
            name: 'Registration',
          },
        ],
      },
      {
        kind: 'INTERFACE',
        name: 'BaseCard',
        possibleTypes: [
          {
            name: 'EventCard',
          },
          {
            name: 'GoalCard',
          },
        ],
      },
      {
        kind: 'INTERFACE',
        name: 'BaseDomain',
        possibleTypes: [
          {
            name: 'ParentDomain',
          },
          {
            name: 'SubDomain',
          },
        ],
      },
      {
        kind: 'UNION',
        name: 'Card',
        possibleTypes: [
          {
            name: 'EventCard',
          },
          {
            name: 'GoalCard',
          },
        ],
      },
      {
        kind: 'UNION',
        name: 'CardLogSubject',
        possibleTypes: [
          {
            name: 'CardComment',
          },
          {
            name: 'CardTask',
          },
          {
            name: 'EventCard',
          },
          {
            name: 'GoalCard',
          },
          {
            name: 'User',
          },
        ],
      },
      {
        kind: 'INTERFACE',
        name: 'Copyable',
        possibleTypes: [
          {
            name: 'CourseResult',
          },
          {
            name: 'Interview',
          },
          {
            name: 'KPB',
          },
        ],
      },
      {
        kind: 'INTERFACE',
        name: 'Creatable',
        possibleTypes: [
          {
            name: 'ClinicalCompetenceCommittee',
          },
          {
            name: 'CompetenceCertificate',
          },
          {
            name: 'CourseResult',
          },
          {
            name: 'FeedbackRequest',
          },
          {
            name: 'FeedbackRound',
          },
          {
            name: 'GeneralFeedback',
          },
          {
            name: 'Interview',
          },
          {
            name: 'KPB',
          },
          {
            name: 'MultiSource',
          },
          {
            name: 'Registration',
          },
          {
            name: 'Residency',
          },
        ],
      },
      {
        kind: 'UNION',
        name: 'FeedbackRoundSubject',
        possibleTypes: [
          {
            name: 'CompetenceCertificate',
          },
          {
            name: 'Interview',
          },
        ],
      },
      {
        kind: 'INTERFACE',
        name: 'Form',
        possibleTypes: [
          {
            name: 'CompetenceCertificate',
          },
          {
            name: 'Interview',
          },
          {
            name: 'KPB',
          },
          {
            name: 'Registration',
          },
        ],
      },
      {
        kind: 'UNION',
        name: 'InviteSubject',
        possibleTypes: [
          {
            name: 'KPB',
          },
        ],
      },
      {
        kind: 'UNION',
        name: 'Item',
        possibleTypes: [
          {
            name: 'LearningResourceArticle',
          },
          {
            name: 'LearningResourceFile',
          },
          {
            name: 'LearningResourceLink',
          },
          {
            name: 'LearningResourceMicroLearning',
          },
        ],
      },
      {
        kind: 'UNION',
        name: 'LinkedCard',
        possibleTypes: [
          {
            name: 'EventCard',
          },
          {
            name: 'GoalCard',
          },
        ],
      },
      {
        kind: 'INTERFACE',
        name: 'Node',
        possibleTypes: [
          {
            name: 'AdminGroup',
          },
          {
            name: 'AttachedFile',
          },
          {
            name: 'AudioTranscript',
          },
          {
            name: 'Badge',
          },
          {
            name: 'CardComment',
          },
          {
            name: 'CardLog',
          },
          {
            name: 'CardTask',
          },
          {
            name: 'CccFormConfig',
          },
          {
            name: 'CccFormConfigSelectionFinalReportResult',
          },
          {
            name: 'CccFormConfigSelectionResult',
          },
          {
            name: 'ClinicalCompetenceCommittee',
          },
          {
            name: 'ClinicalCompetenceCommitteeRespondent',
          },
          {
            name: 'Code',
          },
          {
            name: 'CompetenceCertificate',
          },
          {
            name: 'CompetenceCertificateBatch',
          },
          {
            name: 'CompetenceCertificateSubSkillScore',
          },
          {
            name: 'Contact',
          },
          {
            name: 'Course',
          },
          {
            name: 'CourseEdition',
          },
          {
            name: 'CourseEducator',
          },
          {
            name: 'CourseResult',
          },
          {
            name: 'Dashboard',
          },
          {
            name: 'DashboardFormat',
          },
          {
            name: 'DashboardRole',
          },
          {
            name: 'Download',
          },
          {
            name: 'Draft',
          },
          {
            name: 'EventCard',
          },
          {
            name: 'ExternalAccess',
          },
          {
            name: 'ExternalOauthApplication',
          },
          {
            name: 'FeatureToggle',
          },
          {
            name: 'FeedbackRequest',
          },
          {
            name: 'FeedbackRound',
          },
          {
            name: 'GaiaActivity',
          },
          {
            name: 'GaiaCategory',
          },
          {
            name: 'GaiaFileSync',
          },
          {
            name: 'GaiaTarget',
          },
          {
            name: 'GeneralFeedback',
          },
          {
            name: 'GeneralFeedbackFormConfig',
          },
          {
            name: 'GeneratedReport',
          },
          {
            name: 'Goal',
          },
          {
            name: 'GoalActivity',
          },
          {
            name: 'GoalCard',
          },
          {
            name: 'GoalCardSummary',
          },
          {
            name: 'Guideline',
          },
          {
            name: 'GuidelineAttachment',
          },
          {
            name: 'ImportantNotice',
          },
          {
            name: 'Interview',
          },
          {
            name: 'Invite',
          },
          {
            name: 'Invoice',
          },
          {
            name: 'InvoicePlan',
          },
          {
            name: 'KPB',
          },
          {
            name: 'KPBSubSkillScore',
          },
          {
            name: 'LearningResourceAlertedSetItemForUser',
          },
          {
            name: 'LearningResourceArticle',
          },
          {
            name: 'LearningResourceFile',
          },
          {
            name: 'LearningResourceGlobalCategory',
          },
          {
            name: 'LearningResourceLink',
          },
          {
            name: 'LearningResourceMicroLearning',
          },
          {
            name: 'LearningResourceMicroLearningStep',
          },
          {
            name: 'LearningResourceMicroLearningUserProgress',
          },
          {
            name: 'LearningResourceSet',
          },
          {
            name: 'LedgerAccount',
          },
          {
            name: 'Memo',
          },
          {
            name: 'MultiSource',
          },
          {
            name: 'Note',
          },
          {
            name: 'Notification',
          },
          {
            name: 'OIDC',
          },
          {
            name: 'OnboardingStep',
          },
          {
            name: 'Organization',
          },
          {
            name: 'OrganizationUserRole',
          },
          {
            name: 'ParentDomain',
          },
          {
            name: 'ParticipationLevelFormat',
          },
          {
            name: 'PendingAction',
          },
          {
            name: 'Period',
          },
          {
            name: 'PeriodFormat',
          },
          {
            name: 'PeriodRequiredSkillLevel',
          },
          {
            name: 'Portfolio',
          },
          {
            name: 'PortfolioAssessment',
          },
          {
            name: 'PortfolioDocumentConfig',
          },
          {
            name: 'PortfolioEvent',
          },
          {
            name: 'PortfolioFormat',
          },
          {
            name: 'PortfolioFormatSpecialtyConfig',
          },
          {
            name: 'PortfolioFormatTerminology',
          },
          {
            name: 'PortfolioImport',
          },
          {
            name: 'PortfolioNote',
          },
          {
            name: 'PortfolioQualityCriterion',
          },
          {
            name: 'PortfolioRole',
          },
          {
            name: 'PortfolioRoleSync',
          },
          {
            name: 'PortfolioTransferRequest',
          },
          {
            name: 'Program',
          },
          {
            name: 'ProgramRole',
          },
          {
            name: 'QualityInstrument',
          },
          {
            name: 'Registration',
          },
          {
            name: 'Residency',
          },
          {
            name: 'ResidencyArchetype',
          },
          {
            name: 'RoleFormat',
          },
          {
            name: 'RootSkillCategoryConfig',
          },
          {
            name: 'SecondFactor',
          },
          {
            name: 'SecurityQuestion',
          },
          {
            name: 'Skill',
          },
          {
            name: 'SkillCategory',
          },
          {
            name: 'SkillLevelFormat',
          },
          {
            name: 'SkillLevelFormatDescription',
          },
          {
            name: 'SkillSubSkill',
          },
          {
            name: 'SkillSubSkillAutoScoreMapping',
          },
          {
            name: 'Streak',
          },
          {
            name: 'StreakWeek',
          },
          {
            name: 'SubDomain',
          },
          {
            name: 'SubMultiSource',
          },
          {
            name: 'SupportGroup',
          },
          {
            name: 'UsageStatistic',
          },
          {
            name: 'User',
          },
          {
            name: 'Workspace',
          },
          {
            name: 'WorkspaceRole',
          },
        ],
      },
      {
        kind: 'UNION',
        name: 'PendingActionSubject',
        possibleTypes: [
          {
            name: 'ClinicalCompetenceCommittee',
          },
          {
            name: 'ClinicalCompetenceCommitteeRespondent',
          },
          {
            name: 'CompetenceCertificate',
          },
          {
            name: 'CompetenceCertificateBatch',
          },
          {
            name: 'FeedbackRequest',
          },
          {
            name: 'FeedbackRound',
          },
          {
            name: 'Interview',
          },
          {
            name: 'KPB',
          },
          {
            name: 'MultiSource',
          },
          {
            name: 'PortfolioTransferRequest',
          },
        ],
      },
      {
        kind: 'UNION',
        name: 'PortfolioAssessmentSubject',
        possibleTypes: [
          {
            name: 'CompetenceCertificate',
          },
          {
            name: 'CourseResult',
          },
          {
            name: 'GeneralFeedback',
          },
          {
            name: 'Interview',
          },
          {
            name: 'KPB',
          },
          {
            name: 'MultiSource',
          },
          {
            name: 'Registration',
          },
        ],
      },
      {
        kind: 'INTERFACE',
        name: 'PortfolioItem',
        possibleTypes: [
          {
            name: 'ClinicalCompetenceCommittee',
          },
          {
            name: 'ClinicalCompetenceCommitteeRespondent',
          },
          {
            name: 'CompetenceCertificate',
          },
          {
            name: 'CompetenceCertificateBatch',
          },
          {
            name: 'CourseResult',
          },
          {
            name: 'Download',
          },
          {
            name: 'FeedbackRequest',
          },
          {
            name: 'FeedbackRound',
          },
          {
            name: 'GeneralFeedback',
          },
          {
            name: 'Goal',
          },
          {
            name: 'Interview',
          },
          {
            name: 'KPB',
          },
          {
            name: 'MultiSource',
          },
          {
            name: 'OnboardingStep',
          },
          {
            name: 'PortfolioAssessment',
          },
          {
            name: 'PortfolioEvent',
          },
          {
            name: 'PortfolioTransferRequest',
          },
          {
            name: 'Registration',
          },
          {
            name: 'Residency',
          },
        ],
      },
      {
        kind: 'INTERFACE',
        name: 'SubjectOfFeedbackRound',
        possibleTypes: [
          {
            name: 'CompetenceCertificate',
          },
          {
            name: 'Interview',
          },
        ],
      },
      {
        kind: 'INTERFACE',
        name: 'Timestamped',
        possibleTypes: [
          {
            name: 'AdminGroup',
          },
          {
            name: 'AudioTranscript',
          },
          {
            name: 'Badge',
          },
          {
            name: 'CardComment',
          },
          {
            name: 'CardLog',
          },
          {
            name: 'CardTask',
          },
          {
            name: 'CccFormConfig',
          },
          {
            name: 'CccFormConfigSelectionFinalReportResult',
          },
          {
            name: 'CccFormConfigSelectionResult',
          },
          {
            name: 'ClinicalCompetenceCommittee',
          },
          {
            name: 'ClinicalCompetenceCommitteeRespondent',
          },
          {
            name: 'Code',
          },
          {
            name: 'CompetenceCertificate',
          },
          {
            name: 'CompetenceCertificateBatch',
          },
          {
            name: 'CompetenceCertificateSubSkillScore',
          },
          {
            name: 'Contact',
          },
          {
            name: 'Course',
          },
          {
            name: 'CourseEdition',
          },
          {
            name: 'CourseEducator',
          },
          {
            name: 'CourseResult',
          },
          {
            name: 'Dashboard',
          },
          {
            name: 'DashboardFormat',
          },
          {
            name: 'DashboardRole',
          },
          {
            name: 'Download',
          },
          {
            name: 'Draft',
          },
          {
            name: 'EventCard',
          },
          {
            name: 'ExternalAccess',
          },
          {
            name: 'ExternalOauthApplication',
          },
          {
            name: 'FeatureToggle',
          },
          {
            name: 'FeedbackRequest',
          },
          {
            name: 'FeedbackRound',
          },
          {
            name: 'GaiaActivity',
          },
          {
            name: 'GaiaCategory',
          },
          {
            name: 'GaiaTarget',
          },
          {
            name: 'GeneralFeedback',
          },
          {
            name: 'GeneralFeedbackFormConfig',
          },
          {
            name: 'GeneratedReport',
          },
          {
            name: 'Goal',
          },
          {
            name: 'GoalActivity',
          },
          {
            name: 'GoalCard',
          },
          {
            name: 'Guideline',
          },
          {
            name: 'GuidelineAttachment',
          },
          {
            name: 'ImportantNotice',
          },
          {
            name: 'Interview',
          },
          {
            name: 'Invite',
          },
          {
            name: 'Invoice',
          },
          {
            name: 'InvoicePlan',
          },
          {
            name: 'KPB',
          },
          {
            name: 'KPBSubSkillScore',
          },
          {
            name: 'LearningResourceAlertedSetItemForUser',
          },
          {
            name: 'LearningResourceArticle',
          },
          {
            name: 'LearningResourceFile',
          },
          {
            name: 'LearningResourceGlobalCategory',
          },
          {
            name: 'LearningResourceLink',
          },
          {
            name: 'LearningResourceMicroLearning',
          },
          {
            name: 'LearningResourceMicroLearningStep',
          },
          {
            name: 'LearningResourceMicroLearningUserProgress',
          },
          {
            name: 'LearningResourceSet',
          },
          {
            name: 'LedgerAccount',
          },
          {
            name: 'Memo',
          },
          {
            name: 'MultiSource',
          },
          {
            name: 'Note',
          },
          {
            name: 'Notification',
          },
          {
            name: 'OIDC',
          },
          {
            name: 'OnboardingStep',
          },
          {
            name: 'Organization',
          },
          {
            name: 'OrganizationUserRole',
          },
          {
            name: 'ParentDomain',
          },
          {
            name: 'ParticipationLevelFormat',
          },
          {
            name: 'PendingAction',
          },
          {
            name: 'Period',
          },
          {
            name: 'PeriodFormat',
          },
          {
            name: 'PeriodRequiredSkillLevel',
          },
          {
            name: 'Portfolio',
          },
          {
            name: 'PortfolioDocumentConfig',
          },
          {
            name: 'PortfolioEvent',
          },
          {
            name: 'PortfolioFormat',
          },
          {
            name: 'PortfolioFormatSpecialtyConfig',
          },
          {
            name: 'PortfolioImport',
          },
          {
            name: 'PortfolioNote',
          },
          {
            name: 'PortfolioQualityCriterion',
          },
          {
            name: 'PortfolioRole',
          },
          {
            name: 'PortfolioRoleSync',
          },
          {
            name: 'PortfolioTransferRequest',
          },
          {
            name: 'Program',
          },
          {
            name: 'ProgramRole',
          },
          {
            name: 'QualityInstrument',
          },
          {
            name: 'Registration',
          },
          {
            name: 'Residency',
          },
          {
            name: 'ResidencyArchetype',
          },
          {
            name: 'RoleFormat',
          },
          {
            name: 'RootSkillCategoryConfig',
          },
          {
            name: 'SecondFactor',
          },
          {
            name: 'SecurityQuestion',
          },
          {
            name: 'Skill',
          },
          {
            name: 'SkillCategory',
          },
          {
            name: 'SkillLevelFormat',
          },
          {
            name: 'SkillLevelFormatDescription',
          },
          {
            name: 'SkillSubSkill',
          },
          {
            name: 'SkillSubSkillAutoScoreMapping',
          },
          {
            name: 'StreakWeek',
          },
          {
            name: 'SubDomain',
          },
          {
            name: 'SubMultiSource',
          },
          {
            name: 'SupportGroup',
          },
          {
            name: 'UsageStatistic',
          },
          {
            name: 'User',
          },
          {
            name: 'Workspace',
          },
          {
            name: 'WorkspaceRole',
          },
        ],
      },
      {
        kind: 'UNION',
        name: 'WorkspaceDashboardRole',
        possibleTypes: [
          {
            name: 'DashboardRole',
          },
          {
            name: 'WorkspaceRole',
          },
        ],
      },
    ],
  },
};
